export const HEX_COLOR_REGEX = /^#([a-fA-F0-9]{6}|[a-fA-F0-9]{3})$/;
export const DISCORD_URL_REGEX = /https?:\/\/discord(app)?.com\/api\/webhooks\/([^/]+)\/([^/]+)/; 

export const FIELD_REQUIRED_ERROR = 'Field is required';